import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getAllMessages, getLabels, getMessageByMsgId } from '../api/cmail.api';
import { getData } from '../utils/functional/fp';
import { fetchAttachmentTranscript } from '../console/cmail/utils/audioAttachmentUtils';

export const cmail = createQueryKeys('cmail', {
  detail: (msgId: string) => ({
    queryKey: ['message-details', msgId],
    queryFn: () =>
      getMessageByMsgId({ params: { msgId } }).then((resp) => {
        return resp.data;
      }),
  }),

  batchDetails: (msgIds: string[]) => ({
    queryKey: ['batch-details', msgIds],
    queryFn: async () => {
      const results = await Promise.allSettled(
        msgIds.map((msgId) =>
          getMessageByMsgId({ params: { msgId } }).then((resp) => resp.data)
        )
      );

      return results
        .filter(
          (result) => result.status === 'fulfilled' && result.value !== null
        )
        .map((result) => (result as PromiseFulfilledResult<unknown>).value);
    },
  }),

  list: (filters: Record<string, unknown>) => ({
    queryKey: [{ filters }],
    queryFn: () => getAllMessages({ params: filters }),
  }),

  labels: () => ({
    queryKey: ['labels'],
    queryFn: () => getLabels().then(getData),
  }),

  // Keyed by docId: the signed URL changes on every message fetch.
  attachmentTranscript: (docId: string, url: string) => ({
    queryKey: ['attachment-transcript', docId],
    queryFn: () => fetchAttachmentTranscript(url),
  }),
});
